// 推荐信息
import { Form, Input} from '@roo/roo';
import React from 'react';
import { FieldList } from '../../_components/FieldList';
import { requiredRule, phoneRule, emailRule } from '../../../../utils/rules';
import { UploadField } from '../../_components/UploadField';

const Field = Form.field;

const recommendInfoObj = {
  name: '',
  company: '',
  email: '',
  job: '',
  phone: '',
  letterUrl: '',
};

export const Commend = (props) => {
  return (
    <FieldList
      {...props}
      name={'recommendInfo'}
      minCount={2}
      maxCount={5}
      iniData={recommendInfoObj}
      itemClassName={'bc relative'}
    >
      <Field
        required={true}
        label='推荐人姓名'
        name={`name`}
        rule={{ ...requiredRule }}
        // as={<Input maxLength={50} placeholder='请输入推荐人姓名' />}
      >
        {({ value, handleChange, disabled, idx, item, setFieldValue }) => {
          return (
            <Input
              maxLength={50}
              placeholder='请输入推荐人姓名'
              value={value}
              onChange={(e) => {
                handleChange(e);
                setFieldValue(`recommendInfo.${idx}`, { ...item, name: e.target.value });
              }}
              disabled={disabled}/>
          );
        }}
      </Field>
      <Field
        required={true}
        label='工作单位'
        name={`company`}
        rule={{ ...requiredRule }}
        // as={<Input maxLength={50} placeholder='请输入工作单位' />}
      >
        {({ value, handleChange, disabled, idx, item, setFieldValue }) => {
          return (
            <Input
              maxLength={50}
              placeholder='请输入工作单位'
              value={value}
              onChange={(e) => {
                handleChange(e);
                setFieldValue(`recommendInfo.${idx}`, { ...item, company: e.target.value });
              }}
              disabled={disabled}/>
          );
        }}
      </Field>
      <Field
        required={true}
        label='电子邮箱'
        name={`email`}
        rule={{ ...emailRule }}
        // as={<Input maxLength={50} placeholder='请输入电子邮箱' />}
      >
        {({ value, handleChange, disabled, idx, item, setFieldValue }) => {
          return (
            <Input
              maxLength={50}
              placeholder='请输入电子邮箱'
              value={value}
              onChange={(e) => {
                handleChange(e);
                setFieldValue(`recommendInfo.${idx}`, { ...item, email: e.target.value });
              }}
              disabled={disabled}/>
          );
        }}
      </Field>
      <Field
        label='职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务'
        name={`job`}
        // as={<Input maxLength={50} placeholder='请输入职务' />}
      >
        {({ value, handleChange, disabled, idx, item, setFieldValue }) => {
          return (
            <Input
              maxLength={50}
              placeholder='请输入职务'
              value={value}
              onChange={(e) => {
                handleChange(e);
                setFieldValue(`recommendInfo.${idx}`, { ...item, job: e.target.value });
              }}
              disabled={disabled}/>
          );
        }}
      </Field>
      <Field
        label='手机号码'
        name={`phone`}
        rule={{ ...phoneRule, required: false }}
        // as={<Input maxLength={50} placeholder='请输入手机号码' />}
      >
        {({ value, handleChange, disabled, idx, item, setFieldValue }) => {
          return (
            <Input
              maxLength={50}
              placeholder='请输入工作单位'
              value={value}
              onChange={(e) => {
                handleChange(e);
                setFieldValue(`recommendInfo.${idx}`, { ...item, phone: e.target.value });
              }}
              disabled={disabled}/>
          );
        }}
      </Field>
      {/* <Field
        required={true}
        rule={{ ...requiredRule, required: true }}
        label='推荐函'
        layout='vertical'
        name={`letterUrl`}
      >
        {({ value, handleChange }) => {
          return (
            <UploadField type={'img'} value={value} handleChange={handleChange} />
          )
        }}
      </Field> */}
    </FieldList>
  );
};
